import React from 'react';
import useTeachingOrder from 'state/hooks/use-teaching-order';
import CharacterCard from './CharacterCard';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { Box } from '@mui/material';

const ClassroomReportGrid: React.FC = () => {
  const [{ activeCharacters }] = useTeachingOrder();

  return (
    <Box
      display="grid"
      gridTemplateColumns={`repeat(auto-fit, minmax(${remCalc(176)}, 1fr))`}
      gap={remCalc(24)}
    >
      {activeCharacters.map((character) => (
        <CharacterCard key={character.id} character={character} />
      ))}
    </Box>
  );
};

export default ClassroomReportGrid;
